import { render, staticRenderFns } from "./OneGoodsFlowList.vue?vue&type=template&id=118e110e&scoped=true&"
import script from "./OneGoodsFlowList.vue?vue&type=script&lang=js&"
export * from "./OneGoodsFlowList.vue?vue&type=script&lang=js&"
import style0 from "./OneGoodsFlowList.vue?vue&type=style&index=0&id=118e110e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e110e",
  null
  
)

export default component.exports